import {handleAjaxError} from "./handleAjaxError";

function audiocall() {
    $('.g-chat-btn-audiocall').on('click', function () {
        let chatForm = $('.g-chatform');
        let sessionToken = chatForm.attr('data-session-token');
        let submitBtn = $(this);

        submitBtn.addClass('is-loading');

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                sessionToken: sessionToken,
                action: growtype_chat_ajax.audiocall_action,
                nonce: growtype_chat_ajax.nonce,
            },
            success: function (response) {
                if (response.success) {

                }
            },
            error: function (response) {
                handleAjaxError(response, submitBtn);
            }
        });
    });
}

export {audiocall};
